import { render, staticRenderFns } from "./nokia-brand.vue?vue&type=template&id=08157692"
import script from "./nokia-brand.vue?vue&type=script&lang=js"
export * from "./nokia-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports